import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const deleteShoppingFeedAttribute = async ({ categoryId, attributeId }) => {
  const response = await axiosInstance.delete(
    `/mp_categories/${categoryId}/shoppingfeed-attribute/${attributeId}/`
  );
  return response.data;
};

export const useDeleteShoppingFeedAttribute = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: deleteShoppingFeedAttribute,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mp-attributes'] });
    },
    retry: 0,
  });

  return {
    deleteAttribute: mutation.mutate,
    deleteAttributeAsync: mutation.mutateAsync,
    isDeleting: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    reset: mutation.reset,
  };
};
